module.exports = __webpack_public_path__ + "static/media/fighting.03362755.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fighting.png
// module id = 1875
// module chunks = 0